import { FontFeaturesTableSans, FontFeaturesTableMono } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  FontFeaturesTableSans,
  FontFeaturesTableMono,
  React
};